module.exports = __webpack_public_path__ + "img/base_divers_pharmacie.e5dc4290.svg";